import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaWhatsapp } from 'react-icons/fa';

const GlobalWhatsAppButton = () => {
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const message = 'Hello! I am interested in kitchenware products from your website.';

  // Fetch the admin WhatsApp number from the backend env (WHATSAPP_ADMIN_NUMBER)
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/whatsapp-number`)
      .then(res => setWhatsappNumber(res.data.number || ''))
      .catch(err => console.error('Error fetching WhatsApp number:', err));
  }, []);

  const handleWhatsAppClick = () => {
    if (!whatsappNumber) return;
    const formattedNumber = whatsappNumber.replace(/[^0-9]/g, '');
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp's "Continue to Chat" page, which lets the user choose
    // between the WhatsApp app and WhatsApp Web.
    window.open(`https://wa.me/${formattedNumber}?text=${encodedMessage}`, '_blank');
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <style>
        {`
          @keyframes whatsapp-pulse {
            0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
            70% { box-shadow: 0 0 0 20px rgba(37, 211, 102, 0); }
            100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
          }
          .whatsapp-float-btn {
            animation: whatsapp-pulse 2s infinite;
          }
        `}
      </style>
      <a
        href="#!"
        onClick={(e) => { e.preventDefault(); handleWhatsAppClick(); }}
        className="whatsapp-float-btn"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          zIndex: 99999,
          backgroundColor: '#25D366',
          color: 'white',
          width: '65px',
          height: '65px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '35px',
          boxShadow: '0 8px 24px rgba(37, 211, 102, 0.4)',
          textDecoration: 'none',
          transition: 'all 0.3s ease',
          transform: isHovered ? 'translateY(-5px) rotate(10deg)' : 'translateY(0) rotate(0deg)',
          cursor: 'pointer'
        }}
        title="Chat with Admin on WhatsApp"
        aria-label="Chat with Admin on WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </>
  );
};

export default GlobalWhatsAppButton;
